<template>
  <BaseSearchWrapper
    :filters="filters"
    :hits-per-page="12"
    :index-name="indexName"
    :state-key="stateKey"
    wrapper-classes="w-full flex flex-col gap-y-6"
  >
    <BaseSearchResultsState v-slot="{ isEmptyIndex }: { isEmptyIndex: boolean }">
      <slot
        v-if="isEmptyIndex"
        name="empty"
      >
        <p v-text="noResultsText" />
      </slot>

      <div
        v-else
        class="flex flex-col gap-y-6"
      >
        <div class="flex gap-4 md:items-center max-md:flex-col md:gap-6 lg:gap-12">
          <div class="w-[200px] shrink-0">
            <BaseSearchStats
              :show-query="false"
              result-name-text="webinars"
            />
          </div>

          <div class="flex-1 min-w-[200px] shrink-0">
            <BaseSearchBox placeholder="Search webinars" />
          </div>

          <BaseSearchSort :index-name="indexName" />
        </div>

        <AisHits>
          <template #default="{ items }: { items: AisHit[] }">
            <ul
              v-if="items.length > 0"
              class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
            >
              <WebinarSearchResult
                v-for="item in items"
                :key="item.objectID"
                :result="item"
              />
            </ul>

            <p
              v-else
              v-text="noResultsText"
            />
          </template>
        </AisHits>

        <BaseSearchPagination />
      </div>
    </BaseSearchResultsState>
  </BaseSearchWrapper>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { AisHits } from 'vue-instantsearch/vue3/es'

import BaseSearchBox from '@js/components/search/BaseSearchBox.vue'
import BaseSearchSort from '@js/components/search/BaseSearchSort.vue'
import BaseSearchStats from '@js/components/search/BaseSearchStats.vue'
import BaseSearchWrapper from '@js/components/search/BaseSearchWrapper.vue'
import WebinarSearchResult from '@js/components/search/WebinarSearchResult.vue'
import BaseSearchPagination from '@js/components/search/BaseSearchPagination.vue'
import BaseSearchResultsState from '@js/components/search/BaseSearchResultsState.vue'

import { env } from '@js/utils/env'

import { AisHit } from '@js/types/search/AisHit'

defineOptions({
  name: 'AppWebinarsSearch',
})

withDefaults(
  defineProps<{
    filters: string
    stateKey?: string
  }>(),
  {
    stateKey: '',
  },
)

const noResultsText = 'Your search did not return any results.'

const indexName = computed(() => env.elasticsearch.SEARCH_INDEX)
</script>
